import React from 'react';

import BulkActions from './BulkActions';
import ResultTableActions from './ResultTableActions';

const ActionsSection = ({ selectedRowIds, handleExport, onBulkAction }) => (
    <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <div className="bg-300 mx-3 d-none d-lg-block d-xl-none" style={{ width: '1px', height: '29px' }}></div>
        {Object.keys(selectedRowIds).length > 0 ? (
            <BulkActions onBulkAction={onBulkAction} />
        ) : (
            <ResultTableActions handleExport={handleExport} />
        )}
    </div>
);

export default ActionsSection;